import React from 'react';
import { Box } from '@mui/material';
import logoFull from '../../assets/logo-full.svg';
import logoSmall from '../../assets/logo-small.svg';

interface LogoProps {
  size?: 'small' | 'large';
  variant?: 'full' | 'small';
  sx?: any;
  white?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'large', variant = 'full', sx = {}, white = false }) => {
  const logoSource = variant === 'small' ? logoSmall : logoFull;
  
  const getDimensions = () => {
    if (size === 'small') {
      return {
        width: variant === 'small' ? '120px' : '200px',
        height: variant === 'small' ? '40px' : '60px',
      };
    }
    return {
      width: variant === 'small' ? '180px' : '300px',
      height: variant === 'small' ? '60px' : '80px',
    };
  };

  const dimensions = getDimensions();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: dimensions.width,
        height: dimensions.height,
        ...sx
      }}
    >
      <img 
        src={logoSource} 
        alt="SwapStop Logo" 
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          filter: white ? 'brightness(0) invert(1)' : 'none' // Makes the logo white for dark backgrounds when needed
        }} 
      />
    </Box>
  );
};

export default Logo; 